<template>
  <div class="container-fluid login_page main_style">
    <navbar />
    <b-row style="margin-top: 131px">
      <b-col
        xl="3"
        offset-xl="4"
        lg="3"
        offset-lg="2"
        md="3"
        offset-md="2"
        sm="3"
        offset-sm="1"
        style="text-align: left"
      >
      </b-col>
      <b-col cols="12">
        <div class="rectangle_login">
          <b-row>
            <b-col cols="12">
              <div class="text-center font-title">Forget Password</div>
            </b-col>
            <b-col cols="12">
              <div class="text-center font-sub-title">
                โปรดกรอก อีเมล ของท่าน
              </div>
            </b-col>
          </b-row>
          <b-row v-if="isSendSuccess">
            <b-col cols="12">
              <b-alert show variant="success"
                >ส่งคำร้องขอเปลี่ยนรหัสไปยัง email ของท่านแล้ว</b-alert
              >
            </b-col>
          </b-row>
          <b-form @keyup.enter="fetchForgetPassword">
            <b-row class="mt-3 mx-5">
              <b-col class="text-center">
                <b-form-input
                  v-model="email"
                  class="input_text"
                  placeholder="อีเมล"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form>
          <b-row class="mt-3 mx-5">
            <b-col class="text-center">
              <b-button
                @click="fetchForgetPassword"
                class="text-center my-4 py-3 btn-login btn"
              >
                ยืนยัน
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import Swal from "sweetalert2";
import navbar from "@/components/navbar";
export default {
  data() {
    return {
      email: null,
      isSendSuccess: false,
    };
  },
  components: {
    navbar,
  },
  methods: {
    fetchForgetPassword() {
        this.isSendSuccess = false
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("AuthModule/onForgetPassword", {email: this.email})
            .then((res) => {
                console.log(res);
              if (res && res.code == 200) {
                Swal.hideLoading();
                Swal.clickConfirm();
                this.isSendSuccess = true
              } else {
                Swal.fire({
                  title: res.message,
                  icon: "error",
                });
              }
            });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login_page {
  background-image: url("../assets/images/background/bg_login.svg");
  /* Full height */
  height: auto;
  width: 100%;
  /* Center and scale the image nicely */
  //background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .btn-login {
    background: #db7f50;
    font-weight: bold;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border: 1px solid #828282;
    box-sizing: border-box;
    border-radius: 25px;
  }

  .rectangle_login {
    margin-left: auto;
    margin-right: auto;
    max-width: 559px;
    max-height: 600px;
    min-height: 200px;

    background: #ffffff;
    opacity: 0.95;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  }
}
</style>
